<template src="./ButtonBackComponent.html"></template>
<script>
export default {
  name: 'ButtonBackComponent',
  props: {
    label: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss">
  .btn-back {
    color: #8592a3;
    border-color: #8592a3;
    background: transparent;
    width: 120px;
  }
  .btn-back:hover {
    color: #fff;
    background-color: #8592a3;
    border-color: #8592a3;
    box-shadow: 0 0.125rem 0.25rem 0 rgba(113, 221, 55, 0.4);
    transform: translateY(-1px);
  }
</style>
